import { MessageMarkdown } from "@/components/ui/message-markdown";
import { cn } from "@/lib/utils";

/**
 * What an assistant body may contain. Mentions and internal-link resolution come with the
 * defaults; document evidence is the one capability a transcript has to ask for.
 */
const ASSISTANT_MESSAGE_FEATURES = { documentEvidence: true } as const;

export type AssistantMessageDensity = "default" | "compact";

interface AssistantMessageMarkdownProps {
  content: string;
  /** Absent where there is no project router to navigate; internal links stay plain anchors. */
  onNavigate?: (path: string) => void;
  /** `compact` is the side panel's 13px; the full-width transcript reads at 14px. */
  density?: AssistantMessageDensity;
  className?: string;
}

/**
 * One assistant body, wherever it is shown. The transcript and the eval preview in the admin
 * portal both render through this, so what an admin previews is what the chat draws rather
 * than a lookalike of it — same feature set, same type scale, same block styling.
 */
export function AssistantMessageMarkdown({
  className,
  content,
  density = "default",
  onNavigate,
}: AssistantMessageMarkdownProps) {
  return (
    <MessageMarkdown
      className={cn(
        "leading-relaxed text-foreground",
        density === "compact" ? "text-[13px]" : "text-sm",
        className
      )}
      content={content}
      features={ASSISTANT_MESSAGE_FEATURES}
      onNavigate={onNavigate}
    />
  );
}
